module.exports = __webpack_public_path__ + "static/media/DuplicateSlab-Light.98a31782.ttf";